import assetCategoryService from "../../../../services/assetService/assetCategoryService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_ASSETCATEGORIES } from "../../../../utils/constants";
import { AssetCategoryInterface } from "../../../../models/AssetModel/AssetCategory";

interface DeleteAssetCategoryContext {
  previousAssetCategory: AssetCategoryInterface[];
  deletedAssetCategory: AssetCategoryInterface | undefined;
}

const useDeleteAssetCategory = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    void, // No return data after deletion
    Error,
    string, // ID of the ticket to delete
    DeleteAssetCategoryContext
  >({
    mutationFn: assetCategoryService.Remove, // Remove should take a string ID

    onMutate: (assetCategoryId: string) => {
      const previousAssetCategory =
        queryClient.getQueryData<AssetCategoryInterface[]>([
          CACHE_KEY_ASSETCATEGORIES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      // Optimistically update the cache
      queryClient.setQueryData<AssetCategoryInterface[]>(
        [
          CACHE_KEY_ASSETCATEGORIES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        previousAssetCategory.filter(
          (assetCategory) => assetCategory.id !== assetCategoryId
        ) // Use assetCategoryId to filter
      );

      return {
        previousAssetCategory,
        deletedAssetCategory: previousAssetCategory.find(
          (assetCategory) => assetCategory.id === assetCategoryId
        ),
      };
    },

    onError: (error, assetCategoryId, context) => {
      if (!context) return;

      // Rollback to the previous state in case of error
      queryClient.setQueryData<AssetCategoryInterface[]>(
        [
          CACHE_KEY_ASSETCATEGORIES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousAssetCategory
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeleteAssetCategory;
